// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__jKPES","rootCenter":"LoadMoreObserver_rootCenter__2zAec","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__3qWk0"};